<template>
  <div class="verify-container d-flex justify-content-center align-items-center min-vh-100">
    <div class="verify-card shadow-lg p-4 rounded-4 text-center">
      <div class="mb-3">
        <span class="verify-icon bg-primary bg-gradient text-white">
          <i class="bi bi-envelope-paper"></i>
        </span>
      </div>
      <h3 class="mb-2">Verify your email</h3>
      <p class="text-muted mb-1">
        We have sent a verification link to<br>
        <strong>{{ email }}</strong>.
      </p>
      <p class="text-muted mb-3">
        Please check your inbox (and spam folder) before continuing.
      </p>
      <button
        class="btn btn-primary btn-lg w-100 mb-2"
        :disabled="loading || cooldown > 0"
        @click="resend"
      >
        <span v-if="loading">Sending...</span>
        <span v-else-if="cooldown > 0">
          Resend in {{ cooldown }}s
        </span>
        <span v-else>
          Resend verification email
        </span>
      </button>
      <div v-if="message" class="alert alert-success mt-3">{{ message }}</div>
      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
      <router-link to="/login" class="d-block mt-4 text-decoration-none fw-semibold">
        <i class="bi bi-arrow-left"></i> Back to login
      </router-link>
    </div>
  </div>
</template>
<style scoped>
.verify-container {
  background: linear-gradient(120deg, #f0f4ff 0%, #e0e7ff 100%);
  min-height: 100vh;
}
.verify-card {
  background: #fff;
  max-width: 400px;
  width: 100%;
  border-radius: 1.5rem;
  box-shadow: 0 8px 32px rgba(80, 120, 200, 0.12);
  margin: 2rem auto;
}
.verify-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  box-shadow: 0 2px 8px rgba(80, 120, 200, 0.10);
}
h3 {
  font-weight: 700;
  color: #2d3a5a;
}
.alert {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}
.btn-primary {
  font-weight: 600;
  letter-spacing: 0.03em;
}
.fw-semibold {
  font-weight: 600;
}
</style>

<script>
import axios from "@/axios"; // your existing axios.js

export default {
  name: "VerifyNotice",
  data() {
    return {
      email: this.$route.query.email || "",
      loading: false,
      message: null,
      error: null,
      cooldown: 0,
      timer: null,
    };
  },
  methods: {
    async resend() {
      if (!this.email) {
        this.error = "Email address is missing.";
        return;
      }

      this.loading = true;
      this.error = null;
      this.message = null;

      try {
        const res = await axios.post("/email/resend-verification", {
          email: this.email,
        });

        this.message =
          res.data?.message || "Verification email sent successfully.";

        // Start 60s cooldown
        this.cooldown = 60;
        this.timer = setInterval(() => {
          this.cooldown--;
          if (this.cooldown <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          "Failed to resend verification email.";
      } finally {
        this.loading = false;
      }
    },
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>
